import image1 from '../images/OnePot.jpg'
import image2 from '../images/My-America-cover.jpeg'
import image3 from '../images/watermelon&redbirds.jpg'
import image4 from '../images/Bia.PNG'
import image5 from "../images/Bibi'sKitchen.jpg"

export const StaticReadingList = [
    {
      id: 1,
      name: 'One Pot Three Ways',
      author:'Rachel Ama',
      img: image1,
      description: 'Rachel Ama is reframing vegan cooking. Create a veg-packed centrepiece dish in one pan/pot/tray and choose from three creative and flavoursome ways to either serve it up with just a few ingredients or transform it into something else entirely.',
      twitter: 'Sincere@april.biz',
      instagram:'https://www.instagram.com/rachelama_/?hl=en',
      website:'https://www.rachelama.com/'
    },
    {
      id: 2,
      name: "In Bibi's Kitchen",
      author:'Hawa Hassan',
      img: image5,
      description: 'In this incredible volume, Somali chef Hawa Hassan and food writer Julia Turshen present 75 recipes and stories gathered from bibis (or grandmothers) from eight African nations: South Africa, Mozambique, Madagascar, Comoros, Tanzania, Kenya, Somalia, and Eritrea.',
      twitter: 'https://twitter.com/basbaassauce?lang=en',
      instagram:'https://www.instagram.com/hawahassan/',
      website:'https://www.instagram.com/hawahassan/'

    },
    {
      id: 3,
      name: 'Watermelon ​& Red Birds',
      author:'Nicole A. Taylor',
      img:image3,
      description: 'Watermelon and Red Birds is a call for us all to celebrate Black joy and freedom in its many facets. Nicole Taylor has gifted the world with a breathtaking cookbook that is grounded in history and tradition while keeping one eye on the ever-evolving nature of culture, customs, and foodways.',
      twitter: 'https://twitter.com/foodculturist',
      instagram:'https://www.instagram.com/foodculturist',
      website:'http://www.nicoleataylor.com/'
    },
    {
      id: 4,
      name: 'Bia!',
      author:'Victory Nwabu-Ekeoma',
      img: image4,
      description: 'Bia! – meaning ’food’ in Irish and ‘come’ in Igbo –  is a community storytelling project and print and digital publication. Through the words and images of immigrant and diasporic communities in Ireland, Bia! seeks to document our commonality, counterbalance mainstream food narratives, and celebrate how immigrants and diasporas produce their symbolic presence in Ireland through food.',
      twitter: 'Sincere@april.biz',
      instagram:'https://www.instagram.com/bia_zine/',
      website:'https://victorycne.com/'
    },
    {
      id: 5,
      name: 'My America: Recipes from a Young Black Chef',
      author:'Kwame Onwuachi',
      img: image2,
      description: 'Featuring more than 125 recipes, My America is a celebration of the food of the African Diaspora, as handed down through Onwuachi’s own family history, spanning Nigeria to the Caribbean, the South to the Bronx, and beyond.',
      twitter: 'https://twitter.com/chefkwame?lang=en',
      instagram:'https://www.instagram.com/chefkwameonwuachi',
      website:'https://www.kwameonwuachi.com/'
    }
    
    
  ];

  export const staticVideoList = [
    {
      id: 1,
      name: 'First We Feast',
      author:'Danielson William',
      asset:<iframe width="460" height="315" src="https://www.youtube.com/embed/6oWxf0gYFRU?controls=0&mute=1&autoplay=1&loop=1&modestbranding=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen muted></iframe>,
      description: 'Just someone named Daniel, wanting to spread vibes through my passions of music, food and cannabis. Not a chef, still enrolled and studying at the YouTube Culinary Institute.',
      twitter: 'Sincere@april.biz',
      instagram:'https://www.instagram.com/danielsonwilliams_/?hl=en'
    },
    {
      id: 2,
      name: '@gelen',
      author:'Carolina Gelen',
      asset:<iframe width="460" height="315" src="https://www.youtube.com/embed/k16HJElAt4o?controls=0&mute=1&autoplay=1&vq=large&playlist=k16HJElAt4o&loop=1&modestbranding=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen muted></iframe>,
      description: "I’m from Transylvania, Romania and immigrated to the US in 2021 pursuing my passion for cooking.  I’ve worked in five star restaurants and casual cafes but the best experience was growing up in my mothers kitchen.",
      twitter: 'Sincere@april.biz',
      instagram:'https://www.instagram.com/danielsonwilliams_/?hl=en'
    },
    {
      id: 3,
      name: 'Street Food Icons',
      author:'Munchies',
      asset:<iframe width="460" height="315" src="https://www.youtube.com/embed/videoseries?controls=0&mute=1&autoplay=1&vq=large&list=PLnPDn1Lb79JFjhC17KjxiFU41SKivZfrW&loop=1&modestbranding=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen muted></iframe>,
      description: "We chronicle the global culinary experience with diverse voices that include and come from: chefs and home cooks, makers and consumers, the politics and policies of food, 'front' and 'back of house' restaurant life, old wives' tales, innovative news, and culturally significant indicators in our modern world. ",
      twitter: 'Sincere@april.biz',
      instagram:'https://www.instagram.com/danielsonwilliams_/?hl=en'
    },
    {
      id: 4,
      name: 'Kia Cooks',
      author:'Kia Damon',
      asset:<iframe width="460" height="315" src="https://www.youtube.com/embed/4NFoDBd3vgk?controls=0&mute=1&autoplay=1&playlist=4NFoDBd3vgk&loop=1&modestbranding=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen muted></iframe>,
      description: "Kia Damon is a self-taught chef and proud Floridan woman. While paving her way through kitchens, she launched The Supper Club From Nowhere as a response to the lack of visible Black women in her culinary community.",
      twitter: 'Sincere@april.biz',
      instagram:'https://www.instagram.com/danielsonwilliams_/?hl=en'
    },
    {
      id: 5,
      name: 'Sunday Sessions',
      author:'Big Has',
      asset:<iframe width="460" height="315" src="https://www.youtube.com/embed/eUP_IDzEq-Y?controls=0&mute=1&autoplay=1&playlist=eUP_IDzEq-Y&loop=1&modestbranding=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen muted></iframe>,
      description: "Hello and welcome to Sunday sessions. Here it’s all about no bullshit good food. Whether that’s dishes that remind us of sunshine in the cold or a good old steak and salsa verde. \n \n We’re not here to win awards or cook food you can’t make at home. It’s all about sharing recipes and catching a vibe. Bless up.",
      twitter: '@bighas',
      instagram:'https://www.instagram.com/danielsonwilliams_/?hl=en'
    }      
    
  ];
  